// @ts-nocheck

import {
  selectSearchIsLoading,
  selectSearchQuery,
  selectSearchSuggestion,
} from '../../selectors/search/searchPrimary.selector';
import { selectSearchResults } from '../../selectors/search.selector';
import { type SearchResultsType } from '../../types/search';
import { type Selector } from '../../types/selectors';
import { createDeepEqualSelector } from '../../utils/reselect';

type SearchBarSelectedPropsType = {
  isLoading: boolean;
  query: string;
  suggestion: string;
  results: SearchResultsType;
};

const selectSearchBarProps: Selector<SearchBarSelectedPropsType> = createDeepEqualSelector(
  [selectSearchIsLoading, selectSearchQuery, selectSearchSuggestion, selectSearchResults],
  (isLoading, query, suggestion, results) => ({
    isLoading,
    query,
    suggestion,
    results,
  }),
);

export default selectSearchBarProps;
